import React, { useEffect, useState } from 'react';
import { Input, Form, FormGroup, FormFeedback, Button, Card, CardBody, Spinner } from 'reactstrap';
import { userActions } from '../../actions';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectEmailVerify } from 'src/redux/modules/emailVerifyReducer';
import { selectLoggedInEmail } from 'src/redux/modules/authReducer';
import '../AuthForm.css';

const VerifyEmailForm = () => {
  const emailVerifyState = useSelector(selectEmailVerify);
  const dispatch = useDispatch();
  const [submitted, setSubmitted] = useState(false);
  const [token, setToken] = useState('');
  const loggedInEmail = useSelector(selectLoggedInEmail);
  const navigate = useNavigate();

  useEffect(() => {
    let queryString = window.location.search;

    if (queryString[0] === '?') {
      queryString = queryString.slice(1);
    }

    queryString.split('&').forEach(queryPart => {
      const nameValue = queryPart.split('=');

      if (nameValue[0] === 'code') {
        const token = nameValue[1];
        setToken(token);
        setSubmitted(true);
        dispatch(userActions.verifyToken(loggedInEmail, token, navigate));
      }
    });
  }, [dispatch, loggedInEmail, navigate]);

  const handleChange = (event) => {
    const { value } = event.target;
    setToken(value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    if (token) {
      dispatch(userActions.verifyToken(loggedInEmail, token, navigate));
    }
  };

  const handleResend = (event) => {
    event.preventDefault();
    dispatch(userActions.sendEmailConfirmToken(loggedInEmail));
  };

  const emptySubmission = submitted && !token;
  const invalid = emptySubmission || emailVerifyState.mismatch;

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <Card>
          <CardBody>
            <div className="auth-header">
              <h2>Verify Your Email</h2>
              <p>Please check your email for the verification code</p>
            </div>

            <Form onSubmit={handleSubmit} className="auth-form">
              <FormGroup>
                <label className="form-label" htmlFor="token">Verification Code</label>
                <Input
                  invalid={invalid}
                  name="token"
                  id="token"
                  value={token}
                  placeholder="Enter your code"
                  onChange={handleChange}
                />
                <FormFeedback>Invalid code, please double-check the code in the email.</FormFeedback>
              </FormGroup>

              <Button color="primary" disabled={emailVerifyState.loading}>
                {emailVerifyState.loading ? 'Verifying...' : 'Confirm Email'}
              </Button>

              {emailVerifyState.loading && (
                <div className="auth-spinner">
                  <Spinner type="grow" />
                </div>
              )}

              <div className="auth-footer">
                <p>
                  No code received?{' '}
                  <button type="button" onClick={handleResend} className="btn btn-link p-0">
                    Click to resend
                  </button>
                </p>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default VerifyEmailForm;
